/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_BOXES = gql`
  query GetMyBoxes($filter: MyBoxFilterInput, $options: GetManyOptions) {
    getMyBoxes(filter: $filter, options: $options) {
      content {
        id
        _id
        costumeID
        boxStatus
        paymentStats
        totalAmount
        delegateName
        amountPaid
        totalAmountInUSD
        amountPaidInUSD
        availableTime
        address {
          city
          addressLine1
        }
        user {
          vuid
          firstName
          lastName
          email
          mailAddress {
            addressLine1
            city
          }
          address {
            addressLine1
            city
          }
        }
        delivery {
          isOpted
          partner
          status
          trackingId
        }
        presentation {
          id
          name
          year
          type
          status
          createdAt
        }
        section {
          id
          name
        }
        items {
          costumeType {
            name
            description
            images
            id
            minDownPayment
          }
          costumeFeature {
            id
            name
            alias
            isSingleAttribute
            isVisible
            isMandatory
            costumeAttributes {
              id
              name
              isMandatory
              isSingleVal
              isVisible
              costumeValues {
                id
                name
                inventory
                isVisible
                topupPrice
                images
                disclaimer
                isCostumeValueSold
              }
            }
          }
          costumeAttribute {
            id
            name
            isMandatory
            isSingleVal
            isVisible
            costumeValues {
              id
              name
              inventory
              isVisible
              topupPrice
              images
              disclaimer
              isCostumeValueSold
            }
          }
          costumeValue {
            id
            name
            inventory
            isVisible
            topupPrice
            images
            disclaimer
            isCostumeValueSold
            minDownPayment
          }
        }
        payOrder {
          id
          orderId
          paymentStatus
          updatedAt
          payTxes {
            id
            amount
            mode
            reciptId
            status
            resolutionStatus
            errorMessage
            txId
            createdAt
            payMethod
            createdByUser {
              fullName
              email
            }
          }
        }
        boxTxes {
          action
          actionContent
          box
          createdAt
          displayTitle
          user {
            vuid
            firstName
            lastName
            email
          }
          reason
        }
        isPreBooking
        groupId
      }
    }
    getCurrencyExchangeRate {
      payment_mode
      conversion_rate
      currency
      provider
    }
  }
`;
